'use client'
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {Img} from "@/src/components/common/ui/images/Img";
import Button from "@/src/components/common/ui/buttons/Button";
import { theme } from '@/styles/theme/index.jsx';
import React from 'react';

// Functional component for rendering the 404 error page
const ErrorPage = () => {
    return (
        <StyledErrorPage className='StyledErrorPage'>
            {/* Display an image for the 404 error */}
            <Img src={"/images/static/404.jpg"} alt={'Error Page'}/>
            <Container>
                <Row>
                    <Col sm={{span: 12}} className={'d-flex justify-content-center align-items-center flex-column'}>
                        {/* Display the error message */}
                        <h1>Page not found </h1>
                        {/* Button to navigate back to the home page */}
                        <Button color={'white'} margin={'50px 0 0 0'} marginSm={"30px 0 0 0"} src={"/"} text="Return Home"/>
                    </Col>
                </Row>
            </Container>
        </StyledErrorPage>
    );
};

// Styled component for the 404 error page
const StyledErrorPage = styled.div`
    background: ${theme.colors.themeColor10}; // Background color for the error page
    position: relative;
    height: 100svh; // Full screen height
    overflow: hidden;
    align-items: center;
    justify-content: center;
    display: flex;
    text-align: center;

    h1 {
        font-size: 3rem; // Font size for the error message
        line-height: 3rem;
        color: ${theme.colors.white}; // Text color for the error message

        @media(max-width: 767px) {
            font-size: 2rem; // Adjust font size for smaller screens
            line-height: 2rem;
        }
    }
`;

// Export the component wrapped in React.memo to prevent unnecessary re-renders
export default React.memo(ErrorPage);